/**
 * Enquiry
 * 
 * @Author: Focci
 * @Date: 2023-06-15 10:43:38
 * @Last Modified by: Focci
 * @Last Modified time: 2023-06-15 10:43:38
 */

'use client'

import PropTypes from 'prop-types'
import { Marker, Popup, NavigationControl } from 'react-map-gl'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Mapbox from '@comp/mapbox'
import SVGLocation from '@img/location.svg'
import TitleBar from './TitleBar'
import Enquiry from './Enquiry'

function EnquiryAndMaps({
  logo = '',
  name = '',
  lng = null,
  lat = null,
}) {
  const tp = useTranslations('productspec')

  return (
    <>
      <TitleBar title={tp('enquiry')} />
      <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Enquiry inputType="filled" />
        { !!(lng && lat) && (
          <Mapbox
            style={{ height: '18rem' }}
            initialViewState={{ 
              longitude: lng, 
              latitude: lat, 
              zoom: 18,
              scrollZoom: false
            }}
          >
            {() => (
              <>
                <Marker longitude={lng} latitude={lat} anchor="bottom">
                  <SVGLocation width="1.4rem" height="1.4rem" />
                </Marker>
                <Popup 
                  longitude={lng} 
                  latitude={lat}
                  closeOnClick={false}
                  closeButton={false}
                  anchor="right"
                  className="-ml-3 -mt-2"
                >
                  <Image 
                    src={logo || ''} 
                    width={120} 
                    height={80} 
                    alt={name}
                    className="object-contain w-28 h-16"
                  />
                  <div className="text-center mt-2">{name}</div>
                </Popup>
                <NavigationControl 
                  position="bottom-right"
                  showCompass={false}
                />
              </>
            )}
          </Mapbox>
        )}
        
      </div>
    </>
  )
}

EnquiryAndMaps.propTypes = {
  logo: PropTypes.string,
  name: PropTypes.string,
  lng: PropTypes.number,
  lat: PropTypes.number,
}

export default EnquiryAndMaps
